const KaseyaConnect = () => import('@/views/account/integrations/kaseya/kaseya-connect-view.vue');
const KaseyaManage = () => import('@/views/account/integrations/kaseya/kaseya-manage-view.vue');
import KaseyaMappingRoutes from '@/routes/integrations/kaseya/mapping';
import KaseyaImportRoutes from '@/routes/integrations/kaseya/import';
import store from '@/stores/index';

export default [
    {
        path: '/Integrations/Kaseya/Manage',
        name: 'KaseyaMange',
        component: KaseyaManage,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'integration-settings-page',
            pageTitle: 'Manage Kaseya Integration',
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
        
    },
    {
        path: '/Clients/:clientId/Integrations/Kaseya/Manage',
        name: 'ClientKaseyaMange',
        component: KaseyaManage,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'integration-settings-page',
            pageTitle: 'Manage Kaseya Integration'
        }
    },
    {
        path: '/Integrations/Kaseya/Manage/Connection',
        name: 'KaseyaConnect',
        component: KaseyaConnect,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'integration-settings-page',
            pageTitle: 'Manage Kaseya Integration',
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
        
    },
    {
        path: '/Clients/:clientId/Integrations/Kaseya/Manage/Connection',
        name: 'ClientKaseyaConnect',
        component: KaseyaConnect,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'integration-settings-page',
            pageTitle: 'Manage Kaseya Integration',
        }
        
    },
    ...KaseyaMappingRoutes,
    ...KaseyaImportRoutes
]